import ContentConfig from '../../config/ContentConfig';
import EventEmitter from '../EventEmitter';
import { PlayState } from '../../state/LocalState';
import {
  ApiEvents,
  PlaybackStatusChangeEvent
} from '@kollective-frontend/ksdk-api';
import { DeliveryMode, Playback, PlayType } from '../constants';
import { IPlugin } from '../interfaces';
import contentItemsToItemSources from '../../util/contentItemsToItemSources';

export interface PlaybackStatusChangeEventArgs {
  plugin: IPlugin;
  messageCodes?: number[];
  reason: string;
}

export const getOriginalSettings = (playType?: PlayType): DeliveryMode[] => {
  const playback = ContentConfig.getInstance().playback;
  const p = playType == PlayType.VOD ? playback.vod : playback.live;
  return p.priority.split('').reduce((acc, dm) => {
    switch (dm as Playback) {
      case Playback.BBP:
        acc.push(DeliveryMode.WEBRTC);
        break;
      case Playback.ECDN10:
        acc.push(DeliveryMode.ECDN10);
        break;
      case Playback.ECDN11:
        acc.push(DeliveryMode.ECDN11);
        break;
    }
    return acc;
  }, [] as DeliveryMode[]);
};

const emitPlaybackStatusChangeEvent = (
  args: PlaybackStatusChangeEventArgs
): void => {
  const { play } = args.plugin.state || { play: {} as PlayState };
  const data: PlaybackStatusChangeEvent = {
    messageCodes: args.messageCodes || [],
    method: play.activeMode as DeliveryMode,
    originalSetting: getOriginalSettings(play.playType),
    playType: play.playType,
    reason: args.reason,
    sources: contentItemsToItemSources(args.plugin.contentSources)
  };
  EventEmitter.getInstance().emit(ApiEvents.PLAYBACK_STATUS_CHANGE, { data });
};

export default emitPlaybackStatusChangeEvent;
